<template>
  <div class="person-right">
    <div class="maintop">
        <span>续租申请</span>
    </div>
    <el-divider class="title-divider"></el-divider>
    <div style="color:red" v-if="!isNeedExtend">
        {{nonExtendMsg}}
    </div>
    <el-form ref="form"
          v-else
          :rules="rules"
          :model="form"
          size="small"
          :disabled="formDisabled"
          label-width="150px">
          <el-row>
            <el-col :span="12">
              <h3>申请人信息</h3>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名：">
                {{ userInfo.name }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别：">
                {{ userInfo.sex }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="证件类型：">
                {{ userInfo.certType }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件号码：">
                {{ userInfo.certNo }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.isExtend == true || (form.isExtend == false && form.extendType == 2)">
            <el-col :span="24">
              <el-form-item label="续租状态：">
                <span style="color:#3C94F0">
                    {{form.status}}
                </span>
                <span v-on:click="gotoRentApply()" style="cursor:pointer;" v-if="form.extendType == 1 && form.status == '信息待完善'">点击维护续租申请信息</span>
                <span v-else-if="form.extendType == 2 && form.status == '信息待完善'" style="color:red">
                  提示：请在公租房门户或微信公众号登录新主申请人账号以完成申请信息补充并提交
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <el-col :span="12">
              <h3>合同信息</h3>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同编号：">
                {{ contractInfo.contractNo }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同有效期：">
                {{ contractInfo.beginDate }}~{{ contractInfo.endDate }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="单位名称：">
                {{ contractInfo.companyName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="租赁地址：">
                {{ contractInfo.roomAddress }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <!--表单填写-->
          <el-row>
            <el-col :span="12">
              <h3>续租意见确认</h3>
            </el-col>
          </el-row>
          <el-row v-if="!canExtend">
            <el-col :span="24">
              <div style="margin-left:50px;color:red;">
                  您的享受期已满，不能进行续租，合同到期后只能退租。
              </div>
            </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="享受期：">
                    <p style="font-weight: bold;">共 {{form.maxNormalTerms}} 期 / 剩余 {{form.leftNormalTerms}} 期</p>        
                    <p>其中：历史已享受 {{form.usedNormalTerms}} 期 + 当前合同剩余 {{form.curLeftTerms}} 期</p>
                    <div v-if="form.leftNormalTerms <= 0" style="color:red;">
                      <p style="font-weight: bold;">您的享受期已满，您可以继续申请最多不超过2年的过渡期</p>
                      <p>当前已过渡 {{form.usedTransitionalTerms}} 期 / 剩余 {{ form.leftTransitionalTerms }} 期</p>
                    </div>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="续租意见：" prop="extendType">
                  <el-radio-group v-model="form.extendType">
                    <el-radio :label="1" v-if="canExtend">申请续租</el-radio>
                    <el-radio v-if="coapplicantList.length > 0 && canExtend && form.leftNormalTerms > 0" :label="2">
                      变更主申请人
                      <el-tooltip class="item" effect="dark" content="合同到期后，您可以选择家庭成员中的一员来续租当前房间" placement="top">
                        <i class='el-icon-question'></i>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="0">不再续租</el-radio>
                </el-radio-group>
            </el-form-item>
            </el-col>
          </el-row>          
          <el-row v-if="form.extendType == 1">
              <el-col :span="12">
                  <el-form-item label="是否过渡：" prop="isTransitionalContract">
                    <el-radio-group v-model="form.isTransitionalContract" :disabled="isOnlyTransitional">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="过渡类型：" prop="transitionalContractType">
                      <el-select v-model="form.transitionalContractType" :disabled="!form.isTransitionalContract">
                          <el-option value="1" label="享受期内" v-if="(form.leftNormalTerms > 0)"></el-option>
                          <el-option value="2" label="享受期外" v-if="(form.leftNormalTerms <= 0)"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="form.extendType == 2">
              <el-col :span="24">
                  <el-form-item label="新主申请人：" prop="coapplicantApplyID">
                    <el-table :data="coapplicantList" style="width: 95%" border 
                      ref="coapplicantTable"
                      @selection-change="handleSelectionChange">
                      <el-table-column type="selection" width="80" align="center"></el-table-column>
                      <el-table-column prop="name" label="姓名" align="center">
                      </el-table-column>
                      <el-table-column prop="sex" label="性别" align="center">
                      </el-table-column>
                      <el-table-column prop="certNo" label="证件号码" width="200px" align="center">
                      </el-table-column>
                      <el-table-column prop="relationPrincipal" label="与申请人关系" align="center" >
                      </el-table-column>
                      <el-table-column prop="isChummage" label="是否同住" align="center" >
                      </el-table-column>
                    </el-table>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="24">
                  <el-form-item label="原因：" prop="remark">
                      <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="500" show-word-limit style="width:95%"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
        <el-divider></el-divider>

        <el-row v-if="!formDisabled">
          <el-col :span="24" style="padding-top: 20px; text-align: center">
              <el-button type="primary" size="mini" @click="submit()" :loading="loading">
                  提 交
              </el-button>
          </el-col>
        </el-row>
    </el-form>
  </div>
</template>

<script>
import UserApi from "@/api/user/index";
import { getUserInfo } from "@/store/index";
export default {
  inject: ["reload"],
  data() {
    return {
      // 表单
      form: {
        id: "",
        applyID: "",
        outApplyID:"",
        contractID: "",
        isExtend: "",
        remark: "",
        isTransitionalContract: false,
        transitionalContractType: "",
        coapplicantApplyID: "",
        extendType: "",
        maxTerms:"",
        leftTerms:"",
        usedTerms:"",
        usedTermsTransitional:"",
        curLeftTerms:""
      },
      loading:false,
      formDisabled: false,
      isNeedExtend: false,
      isOnlyTransitional: false,
      canExtend:true,
      nonExtendMsg :"",
      userInfo: {},
      contractInfo: {},
      coapplicantList: [],
      selectedCoapplicant:[],
      rules: {
        extendType:[
            { required: true, message: "请选择续租意见", trigger: "blur" }
        ],
        isTransitionalContract:[
            {
                type: "String",
                required: true,
                validator: (rule, value, callback) => {
                  if(this.form.extendType =="1"){
                    if(value == null){
                        callback(new Error("请选择是否过渡"));
                    }
                    else if(value == false && this.form.leftNormalTerms <= 0){
                        callback(new Error("公租房享受期已满6年，只能选择享受期外过渡"));
                    }
                    else{
                        callback();
                    }
                  }
                  else if(this.form.extendType =="0"){
                    console.log('tag', '')
                  }
                  else{
                    callback();
                  }
                },
                trigger: "change",
            },
        ],
        transitionalContractType:[
            {
                type: "String",
                required: true,
                validator: (rule, value, callback) => {
                if (!value && this.form.extendType == "1" && this.form.isTransitionalContract == "1") {
                    callback(new Error("请选择过渡类型"));                        
                }else{
                    callback();
                }
                },
                trigger: "change",
            },
        ],
        coapplicantApplyID: [
          { 
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if(this.form.extendType == "2"){
                if(this.selectedCoapplicant.length <= 0){
                  callback(new Error("请勾选新的主申请人"));
                }
                else if(this.selectedCoapplicant.length > 1){
                  callback(new Error("只能选一人"));
                }
                else{
                  callback();
                }
              }
              else{
                callback();
              }
            if (this.selectedCoapplicant.length <= 1 && this.form.extendType == "2") {
                callback(new Error("请勾选新的主申请人，只能选一人"));
            }else{
                callback();
            }
            },
            trigger: "change", 
          },
        ],
        remark: [
          { required: true, message: "请输入同意或否的原因", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    gotoRentApply:function(){
      this.$router.push({
        path: "/Apply",
        query: { isExtendRenterInfo: "true" ,id:this.form.outApplyID}
      });
    },
    handleSelectionChange:function(val){
      this.selectedCoapplicant = val;
    },
    getCoapplicantList: function () {
      UserApi.getCoapplicantList().then((res) => {
        this.coapplicantList = res.data;
        var that = this;
        this.coapplicantList.forEach(function (ele) {
          ele.sex = that.$Global.enum.AllowSex[ele.sex].enumText;
        });
        
        this.coapplicantList.forEach(function (ele) {
          for (var i = 0; i < that.$Global.enum.RelationPrincipal.length; i++) {
            if (ele.relationPrincipal == that.$Global.enum.RelationPrincipal[i].enumValue) {
              ele.relationPrincipal = that.$Global.enum.RelationPrincipal[i].enumText;
            }              
          }
          ele.isChummage = (ele.isChummage == true ? "是" : "否");            
        });

        if(this.form.isExtend == false && this.form.extendType == 2){
          var selectedRow;
          var id = this.form.coapplicantApplyID;
          this.coapplicantList.forEach(function(ele){
            if(ele.id == id){
              selectedRow = ele;
            }
          })
          this.$nextTick(function() {
            this.$refs.coapplicantTable.toggleRowSelection(selectedRow);
          })          
        }
      });
    },
    getContractInfo: function () {
      UserApi.getCurrentContract().then((res) => {
        if (res.data != null) {
          this.contractInfo = res.data;
          this.contractInfo.beginDate = this.$moment(
            this.contractInfo.beginDate
          ).format("YYYY-MM-DD");
          this.contractInfo.endDate = this.$moment(
            this.contractInfo.endDate
          ).format("YYYY-MM-DD");
        }
      });
    },

    getExtendInfo: function () {
      UserApi.getExtendInfo()
        .then((res) => {
          if (res.data != null) {
            this.form = res.data;
            // 不为空，代表可以征询或显示征询状态
            this.isNeedExtend = true;
            if(this.form.isExtend != null){
                this.formDisabled = true
                if(this.form.isExtend == false){
                  this.form.extendType = 0;
                  if(this.form.coapplicantApplyID != null && this.form.coapplicantApplyID != ""){
                      this.form.extendType = 2;
                  }
                }
                else if(this.form.isTransitionalContract != null){
                    this.form.extendType = 1;
                    if(this.form.isTransitionalContract){
                      this.form.transitionalContractType = this.form.transitionalContractType.toString();
                    }
                }
            }
            else{
              // 如果享受期已满的，则不能进行续租
              if(this.form.leftNormalTerms + this.form.leftTransitionalTerms <= 0){
                  this.canExtend = false;
              }

              // 享受期内剩余 0期的，只能选择期外过渡
              if(this.form.leftNormalTerms <= 0){
                  //this.radio1 = true;
                  this.form.isTransitionalContract = true;
                  this.form.transitionalContractType = "2";
                  this.isOnlyTransitional = true;
              }
            }

            this.getContractInfo();
            this.getCoapplicantList();           
          }
        },err=>{
          this.nonExtendMsg = err;
        })
        .catch((error) => {
          this.$message({
            message: "获取征询数据失败" + error,
            type: "error",
          });
        });
    },
    submit() {
        this.loading = true;
        var vm = this;
        this.$refs["form"].validate((valid) => {
        if (valid) {
            if(this.form.extendType == 0){
                this.form.isExtend = false;
            }
            else{
                this.form.isExtend = true;
            }
            if(this.form.extendType == 0 || this.form.extendType == 1){
              // 续租及不同意续签
              UserApi.submitExtend(vm.form).then(res=>{
                if (res.success) {
                    this.$alert('续租征询意见已提交成功！', '系统提醒', {
                        confirmButtonText: '确定',
                        callback: () => {
                            this.reload();
                        }
                    });
                } else {
                    this.$message.error(res.reason);
                    this.loading = false;
                }
              },err=>{
                  this.$message.error(err);
                  this.loading = false;
              }).catch(error=>{
                  this.$message.error(error);
                  this.loading = false;
              });
            }
            else if(this.form.extendType == 2){
              // 变更主申请人
              this.form.coapplicantApplyID = this.selectedCoapplicant[0].id;
              UserApi.submitExtendExchange(vm.form).then(res=>{
                if (res.success) {
                    this.$alert('主申请人变更申请已提交成功！请登录【'+this.selectedCoapplicant[0].name+'】的账号完善申请信息并提交！', '系统提醒', {
                        confirmButtonText: '确定',
                        callback: () => {
                            this.reload();
                        }
                    });
                } else {
                    this.$message.error(res.reason);
                    this.loading = false;
                }
              },err=>{
                  this.$message.error(err);
                  this.loading = false;
              }).catch(error=>{
                  this.$message.error(error);
                  this.loading = false;
              });
            }
        }
        else{
          this.loading = false;
        }
      });
    },
    cancle() {
      this.$router.push("/User");
    },
  },
  watch:{
    "coapplicantList":function(){
      
    }
  },
  mounted: function () {
    getUserInfo().then((res) => {
      this.userInfo = res;
      if (res != null) {        
        for (var i = 0; i < this.$Global.enum.CertType.length; i++) {
          if (this.userInfo.certType == this.$Global.enum.CertType[i].enumValue) {
            this.userInfo.certType = this.$Global.enum.CertType[i].enumText;
          }
        }

        for (i = 0; i < this.$Global.enum.AllowSex.length; i++) {
          if (this.userInfo.sex == this.$Global.enum.AllowSex[i].enumValue) {
            this.userInfo.sex = this.$Global.enum.AllowSex[i].enumText;
          }
        }
      }
    });
  },
  activated: function () {
    this.getExtendInfo();

    //this.$refs["form"].clearValidate();
  },
};
</script>

<style scoped>
.el-divider {
  margin: 20px 0 10px 0;
}
.title-divider{
  margin:0px;
}

.el-form-item {
  margin-bottom: 0px;
}

h3::before {
  content: "";
  border: 3px solid #3b93f0;
  background-color: #3b93f0;
  margin-right: 15px;
  border-radius: 4px;
}

.el-col {
  padding-top: 20px;
}

.el-form-item__label {
  font-weight: 400;
  color: #333333;
  font-size: 14px;
}

.el-form-item__content {
  font-weight: 400;
  color: #666666;
  font-size: 14px;
}
</style>